import { Backdrop, Box } from "@mui/material/";
import Grid2 from "@mui/material/Unstable_Grid2";
import { Container } from "@mui/system";
import styles from "./LotOffer.module.css";

import { useAppDispatch, useAppSelector } from "app/hooks";
import OutlinedButton from "components/buttons/OutlinedButton";
import Header from "components/header/Header";
import ValidationErrors from "components/modals/ValidationErrors";
import { MediumText } from "components/typography";
import { patchSeller, selectSeller, removeSellerCertificate, getSeller, patchSellerCertificates, cleanupDestroyedCertificates } from "features/seller/sellerSlice";
import { PostSellerResponseInterface } from "features/seller/updateSeller";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LotOfferButton from "../lotOffer/LotOfferButton";
import { SellerCertificateList } from "./SellerCertificateList";
import SellerInformation from "./SellerInformation";
import SellerMasterData from "./SellerMasterData";
import SellerOptions from "./SellerOptions";
import { selectUserRole } from "features/user/userSlice";

export default function Seller() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [changesSaved, setChangesSaved] = useState(true);
  const [error, setError] = useState("");
  const [isValidationOpen, setValidationOpen] = useState(false);
  const [informationText, setInformationText] = useState<string[]>([]);
  const sellerData = useAppSelector(selectSeller);
  const userRole = useAppSelector(selectUserRole);

  const handleEditCertificate = (row: any) => {
    navigate(`zertifikat_bearbeiten/${row.id}`);
  };
  const handleDeleteCertificate = async (certificateData: any, key: any) => {
    // Implement delete logic
    // dispatch(deleteCertificate(certificateData.id)); // Example
    await dispatch(removeSellerCertificate(certificateData.id))

    let result = await dispatch(patchSellerCertificates())
    const { data, status } = result.payload as { data: any, status: number };

    let isError = false;
    if(data?.data?.errors?.certificates_attributes) {
      isError = true;
      try {
        let errors: string[] = ["Fehler beim Speichern des Zertifikats:"];
        for (const key in data.data.errors.certificates_attributes) {
          const errorGroup = data.data.errors.certificates_attributes[key];
          for (const field in errorGroup) {
            for(const message in errorGroup[field]) {
              if(errors.includes(errorGroup[field][message])) continue;
              errors.push(errorGroup[field][message]);
            }   
          }
        }
        setInformationText(errors);
      } catch (e) {
        setInformationText(["Kann nicht mit einem anderen Anbieterzertifikat des gleichen Typs überlappen."]);
      }
    } else if (status >= 400) {
      isError = true;
      setInformationText(["Fehler beim Speichern des Zertifikats (Status: " + status + ")."]);
    }

    if(isError) {
      setValidationOpen(true);
    } else {
      dispatch(cleanupDestroyedCertificates());
    }
  };
  const handleAddCertificate = () => {
    navigate('zertifikat_hinzufuegen');
  };
  const handleClose = () => {
    setValidationOpen(false);
  }
  const saveChanges = () => {
    dispatch(patchSeller()).then((result) => {
      if (sellerData?.id) {
        dispatch(getSeller({ id: sellerData.id }));
      }
      // navigate("/admin/agentenliste");
      // Check for errors in the result
      const data: PostSellerResponseInterface = (result.payload as any).data as PostSellerResponseInterface;
      if (data?.data?.errors) {
        setValidationOpen(true);
        const allErrors: string[] = [];
        for (const key in data.data.errors) {
          const errorGroup = data.data.errors[key];
          if (Array.isArray(errorGroup)) {
            allErrors.push(...errorGroup);
          } else {
            for (const subKey in errorGroup) {
              const subGroup = errorGroup[subKey];
              for (const field in subGroup) {
                allErrors.push(...subGroup[field]);
              }
            }
          }
        }
        setInformationText(allErrors);
      } else {
        setChangesSaved(true);
      }
    }).catch((err) => {
      setError("Fehler beim Speichern der Änderungen.");
    });
  };

  useEffect(() => {
    if (!changesSaved) {
      setError(""); // Reset error state on component mount
    }
  }, [changesSaved, error]);

  return (
    <>
      <Container
        maxWidth="xl"
        sx={{
          pt: 4,
          pb: 4,
          // ml: 4,
          pl: { lg: 12, md: 14, xs: 13 },
        }}
      >
        <Header 
          backButton 
          backButtonPath={`/${userRole}/verkaeuferliste`}
          header="Verkäufer Stammdaten" 
        />
        <Box
          sx={{
            mt: 3,
          }}
        >
          <div className={styles.LotOfferContainer}>
            <Grid2 container className={` ${styles.sdsd}`}>
              <SellerMasterData className={styles.LotOfferMasterData} />
              <SellerInformation className={styles.LotOfferMasterData} />
              <SellerOptions setChangesSaved={setChangesSaved} />
            </Grid2>
          </div>
        </Box>
        {changesSaved && (
          <Box sx={{ mt: 2 }}>
            <MediumText fWeight="bold" color="#072D26">
              Änderungen wurden gespeichert.
            </MediumText>
          </Box>
        )}
        <Box sx={{ mt: 2, display: "flex", gap: 1 }}>
          <LotOfferButton
            label="Änderungen speichern"
            sx={{ borderRadius: "26px", height: "51px", fontWeight: "bold" }}
            onClick={saveChanges}
            disabled={error.length > 0 || changesSaved}
          />
          <OutlinedButton
            onClick={() => { navigate(`/${userRole}/verkaeuferliste`) }}
          >
            Änderungen VERWERFEN
          </OutlinedButton>
        </Box>
        <SellerCertificateList
          certificateList={sellerData?.certificates}
          handleEditCertificate={handleEditCertificate}
          handleDeleteCertificate={handleDeleteCertificate}
          handleAddCertificate={handleAddCertificate}
        />
        <Backdrop sx={{ backgroundColor: "#grey", zIndex: 1200 }} open={isValidationOpen} onClick={handleClose}>
          <ValidationErrors
            checked={isValidationOpen}
            handleClose={handleClose}
            text={informationText}
          />
        </Backdrop>
      </Container>
    </>
  );
}
